<script setup lang="ts">
import { useFilesStore } from "@/stores/files";
import ConnectingScreen from "@/components/statusPages/ConnectingScreen.vue";
import ExpiredSessionScreen from "@/components/statusPages/ExpiredSessionScreen.vue";
import FinalizedSession from "@/components/statusPages/FinalizedSession.vue";
import MainPage from "@/components/MainPage.vue";
const fileStore = useFilesStore();
</script>

<template>
    <ConnectingScreen v-if="!fileStore.status.isConnected" />
    <FinalizedSession v-else-if="fileStore.status.isFinalized" />
    <ExpiredSessionScreen v-else-if="!fileStore.status.isValidSession" />
    <MainPage v-else />
</template>
